const env = {
  API_BASE_URL: import.meta.env.VITE_API_BASE_URL ?? 'https://backespace.elles.app/api',
} as const;

export default env;
